import MultiChoiceItem from '../../../types/MultiChoiceItem';

export default (data: string[], defaultData: MultiChoiceItem[]): MultiChoiceItem[] => {
  if (data) {
    return defaultData.map(el => (!data.includes(el.id) ? {
      ...el,
      checked: false,
    } : el));
  }

  return defaultData;
};
